import { IBudgetUnitFilterRequest } from '../../../../model/sge/budget-unit/request/budget-unit-filter-request';

export type BudgetUnitSearchState = {
    parameters: IBudgetUnitFilterRequest;
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
}

export const BudgetUnitSearchReducer = (state: BudgetUnitSearchState, action: any): BudgetUnitSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
